import { api, type ApiEnvelope } from './api';
import type { PaginatedResponse, ProductDetail, ProductListItem } from '../types';

export interface ProductQueryParams {
  search?: string;
  collection?: string;
  sort?: 'newest' | 'price_asc' | 'price_desc' | 'rating';
  minPrice?: number;
  maxPrice?: number;
  inStock?: boolean;
  page?: number;
  limit?: number;
}

export const productsService = {
  async list(params: ProductQueryParams = {}) {
    const { data } = await api.get<ApiEnvelope<PaginatedResponse<ProductListItem>>>('/products', { params });
    return data.data;
  },
  async getBySlug(slug: string) {
    const { data } = await api.get<ApiEnvelope<{ product: ProductDetail; relatedProducts: ProductListItem[] }>>(
      `/products/${slug}`,
    );
    return data.data;
  },
};
